/** @jsx jsx */
import { jsx } from "theme-ui"
import React, { useEffect, useState } from "react"
import get from "lodash/get"
import {
  Radio,
  Label,
  Input,
  Select,
  Textarea,
  Button,
  Spinner,
  Checkbox,
} from "@theme-ui/components"
import { useForm } from "react-hook-form"
import queryString from "query-string"
import PropTypes from "prop-types"
import Multiselect from "multiselect-react-dropdown"

import Container from "./container"
import Row from "./row"
import Column from "./column"
import Text from "./text"
let textStates = {}

const Form = ({
  children,
  customStyle,
  formData,
  onSubmit,
  onSuccess,
  noSteps,
  type,
  moveToTopOnSubmit,
  hideFormSelection
}) => {
  const [stepState, setStepState] = React.useState({
    step: 0,
    route: formData.defaultRoute,
    basicDetailsSet: noSteps ? true : false,
    sending: false,
    processing: false,
    sent: false,
    data: {},
    textarray: [],
    routename:
      // formData.selectedForm === "general-information" ? "giroutes" : "pmroutes",
      formData.selectedForm === "general-information"
        ? "giroutes"
        : formData.selectedForm === "project-engagement"
        ? "pmroutes"
        : "routes",
  })
  const [showSomethingElse, setshowSomethingElse] = useState(false)
  const [data, setData] = useState(null)

  const setCharCount = (e, id) => {
    textStates[id] = e.target.value.length
  }

  const {
    register,
    handleSubmit,
    watch,
    errors,
    setValue,
    unregister,
    getValues,
    trigger,
    // formState: { errors },
  } = useForm({
    mode: "onChange",
    submitFocusError: false,
  })
  const watchAllFields = watch()
  const watches = watch(["form"])

  const validateQuestionCondition = (question, data) => {
    if (question.conditionQuestion) {
      let conditionQuestionAnswers = get(
        data ? data : watches,
        `form._${question?.conditionQuestion}`
      )
      if (
        conditionQuestionAnswers?.includes("Lot Assessment") &&
        question.conditionAnswers?.includes("Lot Assessment")
      ) {
        return conditionQuestionAnswers?.includes("Lot Assessment")
      } else if (Array.isArray(conditionQuestionAnswers)) {
        return checkIfCommonValues(
          conditionQuestionAnswers,
          question.conditionAnswers
        )
      } else if (
        conditionQuestionAnswers?.includes("Lot Assessment") &&
        formData?.selectedForm === "general-information" &&
        question?.id === "hb8"
      ) {
        return null
      } else {
        return question.conditionAnswers?.includes(conditionQuestionAnswers)
      }
    } else {
      return true
    }
  }

  function checkIfCommonValues(arr1, arr2) {
    return arr1?.some(item => arr2?.includes(item))
  }

  const registerMultiSelect = name => {
    register(name)
  }

  let currentQuestions = get(
    formData.routes,
    `${stepState.route}.questions`,
    []
  ).map(question => (validateQuestionCondition(question) ? question : null))

  if (!noSteps)
    currentQuestions = currentQuestions.slice(
      0,
      stepState.step >= 0 ? stepState.step + 1 : 0
    )
  let lastCurrentQuestion = currentQuestions[currentQuestions.length - 1]
  let isLastQuestion = stepState.route
    ? formData.routes[stepState.route].questions[
        formData.routes[stepState.route].questions.length - 1
      ] === lastCurrentQuestion || lastCurrentQuestion?.islastquestion === true
    : false

  const renderBasicQuestions = () => {
    const styles = {
      label:
        type === "secondary"
          ? {
              mb: 1,
              mt: type === "secondary" ? 3 : 0,
              fontSize: 2,
              fontWeight: "bold",
            }
          : { mb: 1 },
    }
    return (
      <Row customStyle={{ mb: 4 }}>
        <Column size={type === "secondary" ? [12, 12, 6, 6] : [12, 12, 6, 6]}>
          <Label sx={{ ...styles.label }}>First Name</Label>
          <Input
            name="form.basicDetails.firstName"
            ref={register({
              required: "required",
            })}
            variant={
              get(errors, "form.basicDetails.firstName")
                ? "forms.inputError"
                : "forms.input"
            }
          />
        </Column>
        <Column size={type === "secondary" ? [12, 12, 6, 6] : [12, 12, 6, 6]}>
          <Label sx={{ ...styles.label }}>Last Name</Label>
          <Input
            name="form.basicDetails.lastName"
            ref={register({
              required: "required",
            })}
            variant={
              get(errors, "form.basicDetails.lastName")
                ? "forms.inputError"
                : "forms.input"
            }
          />
        </Column>
        <Column size={type === "secondary" ? [12, 12, 6, 6] : [12, 12, 6, 12]}>
          <Label sx={{ ...styles.label }}>Email Address</Label>
          <Input
            name="form.basicDetails.email"
            ref={register({
              required: "required",
              pattern: /^\S+@\S+$/i,
            })}
            variant={
              get(errors, "form.basicDetails.email")
                ? "forms.inputError"
                : "forms.input"
            }
          />
        </Column>
        {/* check if stepadata.route = "Architect or developer" */}
        {/* if true show two more fields */}
        {stepState.route.match(/Architect/i) || stepState.route.match(/Developer/i) ? (
          <>
            {" "}
            <Column
              size={type === "secondary" ? [12, 12, 6, 6] : [12, 12, 6, 6]}
            >
              <Label sx={{ ...styles.label }}>Company</Label>
              <Input
                name="form.basicDetails.company"
                ref={register({
                  required: "required",
                  // pattern: /^\S+@\S+$/i,
                })}
                variant={
                  get(errors, "form.basicDetails.company")
                    ? "forms.inputError"
                    : "forms.input"
                }
              />
            </Column>
            <Column
              size={type === "secondary" ? [12, 12, 6, 6] : [12, 12, 6, 6]}
            >
              <Label sx={{ ...styles.label }}>Phone</Label>
              <Input
                name="form.basicDetails.phone"
                ref={register({
                  required: "required",
                  pattern: /^[0-9].+$/i,
                })}
                variant={
                  get(errors, "form.basicDetails.phone")
                    ? "forms.inputError"
                    : "forms.input"
                }
              />
            </Column>
          </>
        ) : null}
      </Row>
    )
  }

  const renderSomethingElse = (event, name) => {
    if (event.target.value === "Something else" && event.target.checked) {
      setshowSomethingElse(true)
    } else if (
      event.target.value === "Something else" &&
      !event.target.checked
    ) {
      unregister("form._contact_form_info")
      setshowSomethingElse(false)
    }
  }

  const renderQuestion = question => {
    let name = `form._${question.id}`
    if (question.type === "select" && question.multiple) {
      registerMultiSelect(name)
    }
    return (
      <>
        {question.sectionHeading ? (
          <Text type="h2">{question.sectionHeading}</Text>
        ) : null}
        {question.sectionParagraph ? (
          <Text customStyle={{ mb: 3 }}>{question.sectionParagraph}</Text>
        ) : null}
        <Row customStyle={{ mb: 4 }}>
          <Column size={[12, 12, 12]}>
            {question.question && (
              <>
                <Text type="h3" customStyle={{ mb: 2 }}>
                  {question.question}
                </Text>
                {question.questionParagraph ? (
                  <Text customStyle={{ mb: 3 }}>
                    {question.questionParagraph}
                  </Text>
                ) : null}
              </>
            )}   
          </Column>
          <Column size={[12, 12, 12]}>
            {question.type === "input" ? (
              <Input
                name={name}
                {...(question.required
                  ? {
                      ref: register({
                        required: "required",
                      }),
                      variant: get(errors, name)
                        ? "forms.inputError"
                        : "forms.input",
                    }
                  : { ref: register({}) })}
              />
            ) : null}
            {question.type === "phone" ? (
              <Input
                name={name}
                {...(question.required
                  ? {
                      ref: register({
                        required: "required",
                        minLength: 10,
                        pattern: /^[0-9+()-].+$/i,
                      }),
                      variant: get(errors, name)
                        ? "forms.inputError"
                        : "forms.input",
                    }
                  : {
                      ref: register({ minLength: 10, pattern: /^[0-9.].+$/i }),
                    })}
              />
            ) : null}
            {question.type === "price" ? (
              <>
                <Text type="h4" customStyle={{ my: 2 }}>
                  Price Per Square Foot $
                </Text>
                <Input
                  name={name}
                  {...(question.required
                    ? {
                        ref: register({
                          required: "required",
                          pattern: /^[0-9.].+$/i,
                        }),
                        variant: get(errors, name)
                          ? "forms.inputError"
                          : "forms.input",
                      }
                    : { ref: register({ pattern: /^[0-9.].+$/i }) })}
                />
              </>
            ) : null}
            {question.type === "location" ? (
              <Row>
                <Column size={[12, 12, 12, 12]}>
                  <Label sx={{ mb: 1 }}>Country</Label>
                  <Select
                    name={`${name}.country`}
                    ref={register({
                      required: "required",
                    })}
                    defaultValue="US"
                  >
                    <option value="US">United States</option>
                  </Select>
                </Column>
                <Column size={[12, 12, 12, 12]}>
                  <Label sx={{ mb: 1 }}>Street</Label>
                  <Input
                    name={`${name}.address`}
                    ref={register({})}
                    variant={
                      get(errors, `${name}.address`)
                        ? "forms.inputError"
                        : "forms.input"
                    }
                  />
                </Column>
                <Column size={[12, 12, 6, 4]}>
                  <Label sx={{ mb: 1 }}>City</Label>
                  <Input
                    name={`${name}.city`}
                    ref={register({
                      required: "required",
                    })}
                    variant={
                      get(errors, `${name}.city`)
                        ? "forms.inputError"
                        : "forms.input"
                    }
                  />
                </Column>
                <Column size={[12, 12, 6, 4]}>
                  <Label sx={{ mb: 1 }}>State</Label>
                  <Select
                    name={`${name}.state`}
                    ref={register({
                      required: "required",
                      validate: value => value !== "_",
                    })}
                    variant={
                      get(errors, `${name}.state`)
                        ? "forms.selectError"
                        : "forms.select"
                    }
                    defaultValue="_"
                  >
                    <option value="_" disabled>
                      {formData.dropdownPlaceholderText}
                    </option>
                    <option value="AL">Alabama</option>
                    <option value="AK">Alaska</option>
                    <option value="AZ">Arizona</option>
                    <option value="AR">Arkansas</option>
                    <option value="CA">California</option>
                    <option value="CO">Colorado</option>
                    <option value="CT">Connecticut</option>
                    <option value="DE">Delaware</option>
                    <option value="DC">District Of Columbia</option>
                    <option value="FL">Florida</option>
                    <option value="GA">Georgia</option>
                    <option value="HI">Hawaii</option>
                    <option value="ID">Idaho</option>
                    <option value="IL">Illinois</option>
                    <option value="IN">Indiana</option>
                    <option value="IA">Iowa</option>
                    <option value="KS">Kansas</option>
                    <option value="KY">Kentucky</option>
                    <option value="LA">Louisiana</option>
                    <option value="ME">Maine</option>
                    <option value="MD">Maryland</option>
                    <option value="MA">Massachusetts</option>
                    <option value="MI">Michigan</option>
                    <option value="MN">Minnesota</option>
                    <option value="MS">Mississippi</option>
                    <option value="MO">Missouri</option>
                    <option value="MT">Montana</option>
                    <option value="NE">Nebraska</option>
                    <option value="NV">Nevada</option>
                    <option value="NH">New Hampshire</option>
                    <option value="NJ">New Jersey</option>
                    <option value="NM">New Mexico</option>
                    <option value="NY">New York</option>
                    <option value="NC">North Carolina</option>
                    <option value="ND">North Dakota</option>
                    <option value="OH">Ohio</option>
                    <option value="OK">Oklahoma</option>
                    <option value="OR">Oregon</option>
                    <option value="PA">Pennsylvania</option>
                    <option value="RI">Rhode Island</option>
                    <option value="SC">South Carolina</option>
                    <option value="SD">South Dakota</option>
                    <option value="TN">Tennessee</option>
                    <option value="TX">Texas</option>
                    <option value="UT">Utah</option>
                    <option value="VT">Vermont</option>
                    <option value="VA">Virginia</option>
                    <option value="WA">Washington</option>
                    <option value="WV">West Virginia</option>
                    <option value="WI">Wisconsin</option>
                    <option value="WY">Wyoming</option>
                  </Select>
                </Column>
                <Column size={[12, 12, 6, 4]}>
                  <Label sx={{ mb: 1 }}>Zip</Label>
                  <Input
                    name={`${name}.zip`}
                    ref={register({
                      required: "required",
                      pattern: /^[0-9].+$/i,
                      minLength: 5,
                    })}
                    variant={
                      get(errors, `${name}.zip`)
                        ? "forms.inputError"
                        : "forms.input"
                    }
                  />
                  {errors.zip && (
                    <p>
                      You Must be older then 18 and younger then 99 years old
                    </p>
                  )}
                </Column>
              </Row>
            ) : null}
            {question.type === "textarea" ? (
              <React.Fragment>
                <Textarea
                  name={name}
                  {...(question.required
                    ? {
                        ref: register({
                          required: "required",
                        }),
                        variant: get(errors, name)
                          ? "forms.textareaError"
                          : "forms.textarea",
                      }
                    : { ref: register({}) })}
                  onChange={e => setCharCount(e, question.id)}
                />
                <span
                  style={{
                    fontWeight: 600,
                    color:
                      textStates &&
                      textStates[question.id] &&
                      textStates[question.id] > 500
                        ? "red"
                        : "black",
                    paddingLeft: "8px",
                    fontFamily: "Helvetica Neue,sans-serif",
                  }}
                >
                  {textStates && textStates[question.id]
                    ? textStates[question.id]
                    : 0}
                  /500
                </span>
              </React.Fragment>
            ) : null}

            {question.type === "select" && !question.multiple ? (
              <Select
                defaultValue={question.defaultAnswer || "_"}
                name={name}
                ref={register({
                  required: true,
                  validate: value => value !== "_",
                })}
                variant={
                  get(errors, name) ? "forms.selectError" : "forms.select"
                }
              >  
                {!question.defaultAnswer && (
                  <option value="_" disabled>
                    {formData.dropdownPlaceholderText}
                  </option>
                )}
                {question.answers.map((answer, index) => {
                  return (
                    <option key={index} value={answer.value}>
                      {answer.text}
                    </option>
                  )
                })}
              </Select>
            ) : null}
            {question.type === "select" && question.multiple ? (
              <>
                <Multiselect
                  options={question.answers}
                  selectedValues={question.defaultAnswer}
                  displayValue="text"
                  id={name}
                  onSelect={(selectedList, selectedItem) => {
                    let livingModels = selectedList.map(model => {
                      return model.text
                    })
                    setValue(name, livingModels)
                  }}
                  onRemove={(selectedList, selectedItem) => {
                    setValue(name, selectedList)
                  }}
                  showCheckbox={true}
                ></Multiselect>
                {/* if user select Something else  */}
              </>
            ) : null}
            {question.type === "radio"
              ? question.answers.map((option, index) => (
                  <Label key={index}>
                    <Radio
                      name={name}
                      value={option.value}
                      {...(option.value === question.defaultAnswer
                        ? { defaultChecked: "checked" }
                        : {})}
                      ref={register({ required: true })}
                    />
                    {option.text}
                  </Label>
                ))
              : null}
            {question.type === "checkbox"
              ? question.answers.map((option, index) => (
                  <>
                    <Label key={index} sx={{div:{
                      minWidth:[32]
                    }}}>
                      <Checkbox
                        name={name}
                        value={option.value}
                        {...(option.value === question.defaultAnswer
                          ? { defaultChecked: "checked" }
                          : {})}
                        ref={register({ required: true })}
                        onChange={e => renderSomethingElse(e, name)}
                      />
                      {option.text}
                    </Label>
                    {showSomethingElse && option.text === "Something else" ? (
                      <>
                        {" "}     
                        <Textarea
                          name="form._contact_form_info"
                          {...{
                            ref: register({
                              required: "required",
                            }),
                            variant: get(errors, name)
                              ? "forms.inputError"
                              : "forms.input",
                          }}
                          onChange={e => setCharCount(e, question.id)}
                        />
                        <span
                          style={{
                            fontWeight: 600,
                            color:
                              textStates &&
                              textStates[question.id] &&
                              textStates[question.id] > 500
                                ? "red"
                                : "black",
                            paddingLeft: "8px",
                            fontFamily: "Helvetica Neue,sans-serif",
                          }}
                        >
                          {textStates && textStates[question.id]
                            ? textStates[question.id]
                            : 0}
                          /500
                        </span>
                      </>
                    ) : null}
                  </>
                ))
              : null}
          </Column>
        </Row>
      </>
    )
  }
  const renderRouteSelector = () => (
    // <Row customStyle={{  }}>
    <Row
      customStyle={{
        mb: 4,
        // mx: 1,
        // width: "100%",
      }}
    >
      <Column size={[12, 12, 12]}>
        <>
          <Text type="h3" customStyle={{ mb: 2 }}>
            What best describes your role in this project?
          </Text>
        </>
      </Column>
      <Column size={[12, 12, 12]}>
        <Select
          defaultValue={"_"}
          name="Lead Category"
          customStyle={{ width: "100%" }}
          onChange={e => changeRoute(e.target.value)}
        >
          <option value="_" disabled>
            {formData.dropdownPlaceholderText}
          </option>
          {Object.keys(formData.routes)
            .sort((a, b) => formData.routes[a].order - formData.routes[b].order)
            .map((answer, index) => {
              return (
                <option key={index} value={answer.value}>
                  {answer}
                </option>
              )
            })}
        </Select>
      </Column>
      {/* {Object.keys(formData.routes)
          .sort((a, b) => formData.routes[a].order - formData.routes[b].order)
          .map((buttonType, index) => {
            return (
              <Column
                key={index}
                size={[12, 6, 4, 3]}
                customStyle={{
                  flexWrap: "wrap",
                  my: 2,
                  pl: "6px",
                  maxWidth: [
                    "100%",
                    "50%",
                    type === "secondary" ? `${100 / 3}%` : "25%",
                    type === "secondary" ? `${100 / 3}%` : "20%",
                  ],
                  flexBasis: [
                    "100%",
                    "50%",
                    type === "secondary" ? `${100 / 3}%` : "25%",
                    type === "secondary" ? `${100 / 3}%` : "20%",
                  ],
                }}
              >
                {renderSelectionButton(
                  buttonType,
                  stepState.route,
                  changeRoute
                )}
              </Column>
            )
          })} */}
      {/* </Row> */}
    </Row>
  )

  const doNextStep = data => {
    if (!stepState.basicDetailsSet) {
      setStepState({ ...stepState, basicDetailsSet: true })
    } else if (stepState.route) {
      let nextStep = stepState.step + 1
      while (
        nextStep < formData.routes[stepState.route].questions.length &&
        !validateQuestionCondition(
          formData.routes[stepState.route].questions[nextStep],
          data
        )
      ) {
        nextStep++
      }

      setStepState({ ...stepState, step: nextStep })
    }
    setData(data)
  }
  const changeRoute = type => {
    setStepState({ ...stepState, step: 0, route: type })
  }
  const checkIsLastQuestion = async data => {
    let isMax = false
    for (let char in textStates) {
      if (textStates[char] > 500) isMax = true
    }
    if (isMax) return

    if (isLastQuestion && data.form) {
      if (moveToTopOnSubmit)
        window.scrollTo({ left: 0, top: 0, behavior: "smooth" })
      setStepState({ ...stepState, sending: true, data })
    } else {
      doNextStep(data)
    }
  }

  React.useLayoutEffect(() => {
    const submitGA = () => {
      window &&
        window.gtag &&
        window.gtag("event", "Form submission", {
          event_label: formData.gaEventLabel,
          event_category: "Event",
          non_interaction: true,
        })
      /* For google converion apis */
      window &&
        window.gtag &&
        window.gtag("event", "conversion", {
          send_to: `AW-799114647/${formData.conversionDetail}`,
          value: 1.0,
          currency: "USD",
        })
      window && window.gtag && window.gtag("config", "AW-799114647")
    }
    const sendForm = async data => {
      let requestData = {
        ...formData.defaultFields,
      }
      const referralLink =
        type === "secondary"
          ? window.location.href
          : queryString.parse(window.location.search).ref
      if (formData.referralLinkField && referralLink) {
        requestData[formData.referralLinkField] = referralLink
      }
      if (formData.basicQuestions)
        requestData = {
          ...requestData,
          first_name: data.form.basicDetails.firstName,
          last_name: data.form.basicDetails.lastName,
          email: data.form.basicDetails.email,
          company: data.form.basicDetails.company,
          phone: data.form.basicDetails.phone,
        }
      for (const question of currentQuestions) {
        if (question && question.id) {
          const answer = get(data, `form._${question.id}`)
          if (answer && question.type !== "location") {
            if (Array.isArray(answer)) {
              let answerString = answer.join()
              requestData[question.fieldName] = answerString
            } else {
              requestData[question.fieldName] = answer
            }
          } else if (answer) {
            requestData.state = get(data, `form._${question.id}.state`)
            requestData.city = get(data, `form._${question.id}.city`)
            requestData.address = get(data, `form._${question.id}.address`)
            requestData.country = get(data, `form._${question.id}.country`)
            requestData.zip = get(data, `form._${question.id}.zip`)
          }
        }
      }
      if (get(data, `form._contact_form_info`)) {
        requestData["Contact Form Info"] = get(data, `form._contact_form_info`)
      }
      if (
        stepState.route.match(/Architect/i) &&
        formData.selectedForm === "project-engagement"
      ) {
        requestData["Initial Land Status"] = "Own Lot"
      }
      if (formData.routes[stepState.route]?.hiddenFields) {     
        requestData = {
          ...requestData,
          ...formData.routes[stepState.route]?.hiddenFields,
        }
      }
      if (localStorage.getItem("parameter")) {
        let urlformdata = JSON.parse(localStorage.getItem("formObj"))
        requestData = {
          ...requestData,
          ...urlformdata,
        }
      }
      if (onSubmit) {
        onSubmit(requestData)
      }    
      submitGA()
      textStates = {}
      let response
      let res
      if (formData.method === "GET") {
        if (formData.callOnlyloggerUrl) {
          // logger api call
          res = await fetch(  
            queryString.stringifyUrl(
              {
                url: "https://api.plantprefab.com/v1/logger/",
                query: requestData,
              },
              { encode: true, sort: false },
              {
                method: "GET",
              }
            )
          )
            .then(response => response.json())
            .catch(error => console.log("Request failed", error))
        } else {
          // logger api call
          res = await fetch(       
            queryString.stringifyUrl(    
              {
                url: "https://api.plantprefab.com/v1/logger/",
                query: requestData,
              },
              { encode: true, sort: false },
              {
                method: "GET",
              }
            )
          )
            .then(response => response.json())
            .catch(error => console.log("Request failed", error))
          // agile Crm api call
          response = await fetch(
            queryString.stringifyUrl(
              { url: formData.url, query: requestData },
              { encode: true, sort: false }
            ),
            {
              method: "GET",
            }
          )
        }
      }

      if (formData.callOnlyloggerUrl) {
        if (res === "Success!") {
          if (onSuccess) onSuccess(requestData)
          setStepState({ ...stepState, sending: false, sent: true });
        }
      } else {
        if (response.status === 200) {
          if (onSuccess) onSuccess(requestData)
          setStepState({ ...stepState, sending: false, sent: true });
          // hideFormSelection()
        }
      }
    }      

    if (stepState.sending && !stepState.processing) {
      sendForm(stepState.data)
      setStepState({ ...stepState, processing: true })
      hideFormSelection()
    }
  }, [stepState, currentQuestions, formData, onSubmit, onSuccess, type]);


  return (
    <Container customStyle={{ ...customStyle }}>       
      {!(stepState.sent || stepState.sending) ? children : null}
      {stepState.sent ? (
        <Text type="h2">{formData.thankYouMessage}</Text>
      ) : stepState.sending ? (      
        <Spinner />
      ) : (
        <Row>
          <Column size={[12, 12, 6]}> 
            <form onSubmit={handleSubmit(checkIsLastQuestion)}>
              {/* remove condition stepState.basicDetailsSet...first fields to be shown now */}
              {Object.keys(formData.routes).length > 1
                ? renderRouteSelector()
                : null}
              {/* don't show this as default now...check condition if stepstate.route  */}
              {formData.basicQuestions && stepState.route
                ? renderBasicQuestions()
                : null}
              {stepState.route &&
                stepState.basicDetailsSet &&
                currentQuestions.map((question, index) => (
                  <div key={index}>{question && renderQuestion(question)}</div>
                ))}
              {!stepState.basicDetailsSet ? (
                <Button type="submit" variant="forms.buttonChevron">
                  {formData.nextButtonText}
                </Button>        
              ) : null}
              {stepState.basicDetailsSet &&
              stepState.route &&
              type !== "secondary" ? (
                <Button type="submit" variant="forms.buttonChevron">
                  {isLastQuestion
                    ? formData.submitButtonText
                    : formData.nextButtonText}
                </Button>
              ) : null}
              {type === "secondary" ? (
                <Button
                  type="submit"
                  variant="forms.buttonChevron"
                  sx={{ background: stepState.route ? null : "#888" }}
                  disabled={!stepState.route}
                >
                  {formData.submitButtonText}
                </Button>
              ) : null}
            </form>
          </Column>
        </Row>
      )}
    </Container>
  )
}
Form.propTypes = {
  children: PropTypes.node,
  customStyle: PropTypes.object,
  formData: PropTypes.object,
  onSubmit: PropTypes.func,
  onSuccess: PropTypes.func,
}
export default Form
